var IconButton            = require("app/ui/IconButton"),
    Image                 = require("app/ui/Image"),
    PageBackgroundSupport = require("app/ui/PageBackgroundSupport"),
    PopupLayout           = require("app/AppLayout/PopupLayout"),
    ScrollerPopup         = require("app/ui/ScrollerPopup"),
    Spinner               = require("app/ui/Spinner"),
    ImageOptimizerSupport = require("app/ui/ImageOptimizerSupport"),
    closeButtonThemeVars  = require("app/theme/IconButtonVariables--close"),
    frameThrottle         = require("enyo-perf/utils").frameThrottle,
    kind                  = require("enyo/kind"),
    utils                 = require("enyo/utils"),
    themeVars             = require("app/theme/variables.js");

require("./PrintRequestPopup.less");
require("app/theme/IconButton--neutral.less");
require("material-icons/cancel.svg");
require("material-icons/open-in-new.svg");

module.exports = kind(/** @lends  app.Fotocadeau.PrintRequestPopup.prototype */ {

    /**
     * @private
     */
    name: "app.Fotocadeau.PrintRequestPopup",

    /**
     * @private
     */
    kind: ScrollerPopup,

    /**
     * @private
     */
    mixins: [
        ImageOptimizerSupport,
        PageBackgroundSupport
    ],

    /**
     * @private
     */
    layoutKind: PopupLayout,

    /**
     * @private
     */
    layoutOptions: {
        alignment:       "fullLayout",
        expand:          false,
        overlapSafeArea: false,

        /**
         * @returns {number} The margin in pixels
         */
        marginTop: function() {
            return themeVars.getContentPaddingVerticalPx()
                + (this.container.get("showCloseButton")
                    ? closeButtonThemeVars.getIconSize() / 2
                    : 0);
        },

        /**
         * @returns {number} The margin in pixels
         */
        marginBottom: function() {
            return themeVars.getContentPaddingVerticalPx();
        }
    },

    /**
     * @private
     */
    classes: "app-fotocadeau-print-request-popup",

    /**
     * @public
     */
    theme: "bordered",

    /**
     * No close button for this one.
     *
     * @public
     */
    showCloseButton: true,

    /**
     * Status of the request for a print url:
     *  * -1 No `shopLink`, no pending request
     *  * 0 No `shopLink`, pending request
     *  * 1 `shopLink` ready
     *
     * @type {number}
     * @public
     */
    requestStatus: -1,

    /**
     * The link to the shop page
     *
     * @type {string=}
     * @public
     */
    shopLink: null,

    /**
     * @private
     */
    components: [{
        name:       "message",
        classes:    "app-fotocadeau-print-request-popup__message",
        components: [{
            name:       "content",
            classes:    "app-fotocadeau-print-request-popup__content",
            components: [{
                name:       "logo",
                kind:       Image,
                classes:    "app-fotocadeau-print-request-popup__logo",
                src:        require("app/theme/assets/fotocadeau-logo.png"),
                attributes: {
                    loading:  "eager",
                    decoding: "sync"
                },

                /**
                 * @returns  {Object}  The dimensions
                 * @private
                 */
                resolveImageDimensions: function() {
                    return {
                        width: 320
                    };
                }
            }, {
                name:    "title",
                classes: "app-fotocadeau-print-request-popup__title",
                tag:     "h2"
            }, {
                name:               "spinner",
                kind:               Spinner,
                classes:            "app-fotocadeau-print-request-popup__spinner",
                usePerformanceMode: true,
                showing:            false
            }, {
                classes:    "app-fotocadeau-print-request-popup__buttons",
                components: [{
                    name:    "shopButton",
                    kind:    IconButton,
                    classes: "app-fotocadeau-print-request-popup__shop-button",
                    ontap:   "onShopButtonTap",
                    theme:   "neutral",
                    icon:    "open-in-new",
                    showing: false
                }, {
                    name:    "cancelButton",
                    kind:    IconButton,
                    classes: "app-fotocadeau-print-request-popup__cancel-button",
                    ontap:   "onCancelButtonTap",
                    theme:   "neutral",
                    icon:    "cancel",
                    showing: false
                }]
            }]
        }]
    }],

    /**
     * @private
     */
    observers: {
        update: ["requestStatus", "shopLink"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @public
     */
    update: function() {
        var i18nService   = this.app.$.i18nService,
            $title        = this.$.title,
            $spinner      = this.$.spinner,
            $shopButton   = this.$.shopButton,
            $cancelButton = this.$.cancelButton;

        switch (this.requestStatus) {
            case 0:
                $title.set("content", i18nService.getString("app.Fotocadeau.PrintRequestPopup.LoadingTitle"));
                $spinner.show();
                $shopButton.hide();
                $shopButton.set("caption", "");
                $shopButton.set("tooltip", "");
                $cancelButton.hide();
                $cancelButton.set("caption", "");
                $cancelButton.set("tooltip", "");
                break;
            case 1:
                if (this.shopLink) {
                    $title.set("content", i18nService.getString("app.Fotocadeau.PrintRequestPopup.SuccessTitle"));
                    $spinner.hide();
                    $shopButton.set("caption", i18nService.getString("app.Fotocadeau.PrintRequestPopup.ShopButton.caption"));
                    $shopButton.set("tooltip", i18nService.getString("app.Fotocadeau.PrintRequestPopup.ShopButton.tooltip"));
                    $shopButton.show();
                    $cancelButton.hide();
                    $cancelButton.set("caption", "");
                    $cancelButton.set("tooltip", "");
                }
                else {
                    $title.set("content", i18nService.getString("app.Fotocadeau.PrintRequestPopup.FailTitle"));
                    $spinner.hide();
                    $shopButton.hide();
                    $shopButton.set("caption", "");
                    $shopButton.set("tooltip", "");
                    $cancelButton.set("caption", i18nService.getString("app.Fotocadeau.PrintRequestPopup.CancelButton.caption"));
                    $cancelButton.set("tooltip", i18nService.getString("app.Fotocadeau.PrintRequestPopup.CancelButton.tooltip"));
                    $cancelButton.show();
                }
                break;
            case -1:
            default:
                break;
        }

        this.resize();
    },

    /**
     * Close the popup and cancel the print request.
     *
     * @returns  {boolean}  Stop propagation of the tap event
     * @private
     */
    onShopButtonTap: function() {
        var shopLink = this.get("shopLink");

        if (shopLink) {
            window.open(shopLink, "_blank");
        }
        this.close();

        return true;
    },


    /**
     * Close the popup and cancel the print request.
     *
     * @param    {enyo.Control}  sender  The sender
     * @param    {Object}        event   The tap event
     * @returns  {boolean}       Stop propagation of the tap event
     * @private
     */
    onCancelButtonTap: function(sender, event) {
        return this.onCloseButtonTap(sender, event);
    },

    /**
     * Close the popup and cancel the print request.
     *
     * @param    {enyo.Control}  sender  The sender
     * @param    {Object}        event   The tap event
     * @returns  {boolean}       Stop propagation of the tap event
     * @private
     */
    onCloseButtonTap: kind.inherit(function(sup) {
        return function(sender, event) {
            var vent;

            sup.apply(this, arguments);

            vent               = utils.clone(event);
            vent.originator    = sender;
            vent.originalEvent = event;
            delete vent.delegate;
            this.bubbleUp("onCancelPrintRequest", vent);

            return true;
        };
    })

});
